/**
 * App 级 chrome 宿主：H5 挂到 body，不随页面栈销毁。
 * uni-app 的 App.vue 模板里自定义兄弟节点不会进页面树，必须单独挂载。
 */
import { createApp, h, type Plugin } from 'vue';
import type { Pinia } from 'pinia';
import AppChrome from '@/components/app-chrome/index.vue';

let hostMounted = false;

export const isAppChromeHostMounted = () => hostMounted;

function ensureAppChromeHost(pinia: Pinia, i18n: Plugin) {
  if (hostMounted || typeof document === 'undefined') return;
  if (document.getElementById('app-chrome-root')) {
    hostMounted = true;
    return;
  }

  const el = document.createElement('div');
  el.id = 'app-chrome-root';
  document.body.appendChild(el);

  const hostApp = createApp({
    render: () => h(AppChrome),
  });
  hostApp.use(pinia);
  hostApp.use(i18n);
  hostApp.config.warnHandler = () => undefined;
  hostApp.mount(el);
  hostMounted = true;
}

/** 在 createApp 且 app.use(pinia / i18n) 之后调用 */
export function installAppChrome(pinia: Pinia, i18n: Plugin): void {
  if (typeof document === 'undefined') return;
  const mount = () => ensureAppChromeHost(pinia, i18n);
  if (document.body) mount();
  else document.addEventListener('DOMContentLoaded', mount, { once: true });
}
